import MainContent from "./mainContent";

function MainDashboard() {
    return (
        <div id="dashboard" className="min-h-screen">
            <div className="flex">
                <MainContent />
            </div>
        </div>
    )
}

export default MainDashboard;